import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  Input,
  useToast,
} from "@chakra-ui/react";
import { MdOutlineAdd } from "react-icons/md";
import { editarReportesViajes } from "../../../helpers/api.helper";

const AgregarNroremito = (props) => {
  const { reporte, reportesViajes, setReportesViajes, user } = props;
  const [nroRemito, setNroRemito] = useState();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();

  const handleAgregar = async () => {
    let res;

    res = await editarReportesViajes({
      id: reporte.idReporteViaje,
      numRemitoRV: nroRemito.toString(),
    });

    if (res.status === 200) {
      let editar = reportesViajes.find(
        (item) => item.idReporteViaje === reporte.idReporteViaje
      );
      const indexFechaDetencion = reportesViajes.findIndex(
        (detalle) => detalle.idReporteViaje === reporte.idReporteViaje
      );
      if (editar) {
        editar = { ...reporte, numRemitoRV: nroRemito.toString() }; // Corrección aquí
      }
      if (indexFechaDetencion !== -1) {
        // Añadida verificación para evitar errores si el índice no se encuentra
        reportesViajes[indexFechaDetencion] = editar;
      }
      setReportesViajes([...reportesViajes]);
      onClose();
      toast({
        title: "Exito",
        description: "Numero de remito agregado",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
    } else {
      toast({
        title: "Error",
        description: "Error al cargar Nro. de remito",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <>
      <Button
        variant="link"
        leftIcon={<MdOutlineAdd color="#FF8200" />}
        onClick={onOpen}
        size="sm"
      >
        Agregar
      </Button>
      <Modal size="sm" isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent borderRadius="20px">
          <ModalHeader placeSelf="center" fontWeight="bold">
            Numero de Remito
          </ModalHeader>
          <ModalCloseButton size="sm" />
          <ModalBody>
            <Input
              placeholder="Nro. de remito"
              borderRadius="20px"
              onChange={(e) => setNroRemito(e.target.value)}
              type="number"
            />
          </ModalBody>

          <ModalFooter placeContent="center">
            <Button
              bg="brand.naranja"
              fontSize="14px"
              color="white"
              onClick={() => handleAgregar()}
              isDisabled={user.idRol === "usuarioIT"}
            >
              Cargar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default AgregarNroremito;
